const CustomJS = (function () {
  /**
   * Initialize any #announcement-canvas elements under `scope`
   */
  function initAnnouncementLottie(scope = document) {
    import("https://cdn.jsdelivr.net/npm/@lottiefiles/dotlottie-web/+esm")
      .then(({ DotLottie }) => {
        scope.querySelectorAll("#announcement-canvas").forEach((canvasEl) => {
          new DotLottie({
            canvas: canvasEl,
            src: "https://cdn.shopify.com/s/files/1/0676/6775/5208/files/Sobaka.lottie?v=1750946849",
            autoplay: true,
            loop: true,
            background: "transparent",
          }).load();
        });
      })
      .catch((err) => console.error("Failed to load DotLottie:", err));
  }

  /**
   * Sets up the accordion functionality for footer blocks
   */
  function setupFooterAccordion() {
    const titles = document.querySelectorAll(".footer-block__title");

    titles.forEach((title) => {
      title.addEventListener("click", function () {
        const parent = title.parentElement;
        const nestedMenu = parent.querySelector(".nested-menu");

        // Close all other menus
        document.querySelectorAll(".nested-menu").forEach((menu) => {
          if (menu !== nestedMenu) {
            menu.classList.remove("active");
          }
        });

        document
          .querySelectorAll(".footer-block__title")
          .forEach((otherTitle) => {
            if (otherTitle !== title) {
              otherTitle.classList.remove("active");
            }
          });

        // Toggle the clicked menu
        nestedMenu.classList.toggle("active");
        title.classList.toggle("active");
      });
    });
  }

  function setupRecommendationsCarousel() {
    new Swiper(".product-recommendations-swiper", {
      slidesPerView: 2.25,
      spaceBetween: 16,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
      },
    });
  }

  function setupCartRecommendations(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;

    if (
      containerId === "cart-recommendations-desktop-container" &&
      window.innerWidth < 768
    ) {
      container.style.display = "none";
      return;
    }
    if (
      containerId === "cart-recommendations-mobile-container" &&
      window.innerWidth >= 768
    ) {
      container.style.display = "none";
      return;
    }

    const rootEl = container.querySelector('[id^="cart-recommendations"]');
    const productId = rootEl?.dataset.productId;
    const cartProductIds = rootEl?.dataset.cartProductIds
      .split(",")
      .map(Number);
    const target = container.querySelector(".js-recommendation-cards");
    const loadingSpinner = container.querySelector(".recommendations-loading");
    if (!productId || !target || !loadingSpinner) return;

    if (container._forceHoverInterval) {
      clearInterval(container._forceHoverInterval);
      container._forceHoverInterval = null;
    }

    const isVisible = (el) => {
      const rect = el.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    };

    fetch(
      `/recommendations/products?section_id=cart-recommendations-render&product_id=${productId}&limit=6`
    )
      .then((r) => r.text())
      .then((html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        const recommendationCards = Array.from(
          tempDiv.querySelectorAll(".cart-recommendation-product")
        );

        const blockedProductIds = [
          7764650360880, 7764650328112, 7764652163120, 7764650295344,
        ];

        recommendationCards.forEach((card) => {
          const id = parseInt(card.dataset.productId, 10);
          if (Number.isNaN(id)) return;
          if (blockedProductIds.includes(id)) return;
          if (!cartProductIds.includes(id)) target.appendChild(card);
        });

        if (!target.children.length) {
          loadingSpinner.style.display = "none";
          return;
        }
        loadingSpinner.style.display = "none";
        target.style.display = "flex";

        const cards = Array.from(
          target.querySelectorAll(".cart-recommendation-product")
        ).filter(
          (card) =>
            card.querySelector(".card__media.has-video") &&
            card.querySelector("button")
        );

        cards.forEach((c) => {
          c.querySelector(".card__media.has-video").classList.remove(
            "force-hover"
          );
          c.querySelector("button").classList.remove("waggle-animation");
        });

        let prevIdx = -1;
        const highlightNext = () => {
          if (!isVisible(container) || !cards.length) return;

          let idx;
          do {
            idx = Math.floor(Math.random() * cards.length);
          } while (idx === prevIdx && cards.length > 1);

          if (prevIdx >= 0) {
            const prev = cards[prevIdx];
            prev
              .querySelector(".card__media.has-video")
              .classList.remove("force-hover");
            prev.querySelector("button").classList.remove("waggle-animation");
          }

          const curr = cards[idx];
          curr
            .querySelector(".card__media.has-video")
            .classList.add("force-hover");
          const btn = curr.querySelector("button");
          btn.classList.remove("waggle-animation");
          btn.offsetWidth;
          btn.classList.add("waggle-animation");

          prevIdx = idx;
        };

        highlightNext();
        container._forceHoverInterval = setInterval(highlightNext, 2000);

        if (typeof setupLazyVideos === "function") setupLazyVideos();
      })
      .catch((err) => {
        console.error("Error loading recommendations:", err);
        loadingSpinner.style.display = "none";
      });
  }

  /**
   * Initializes the Swiper instance for the product collection carousel on homepage
   */
  function setupCollectionCarousel() {
    new Swiper(".bestsellers-swiper", {
      slidesPerView: 2.2,
      spaceBetween: 16,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
      },
    });
  }

  /**
   * Initializes the Swiper instance for the wheel carousel on homepage
   */
  function setupWheel() {
    new Swiper(".wheel-carouselr", {
      effect: "coverflow",
      centeredSlides: true,
      loop: true,
      spaceBetween: 40,
      slidesPerView: "auto",
      allowTouchMove: false,
      updateOnWindowResize: false,
      touchStartPreventDefault: false,
      speed: 1000,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false,
      },
      breakpoints: {
        750: {
          spaceBetween: 64,
          slidesPerView: "auto",
        },
      },
      cssMode: false,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 150,
        modifier: 1,
        slideShadows: false,
      },
    });
  }
  /**
   * Initializes the Swiper instance for the testimonial carousel on homepage
   */
  function setupTestimonial() {
    new Swiper(".testimonial-swiper", {
      loop: true,
      slidesPerView: 1.3,
      effect: "slide",
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        990: {
          slidesPerView: 2.5,
        },
      },
    });
  }

  function setupMediaSlider() {
    new Swiper(".media-slider", {
      loop: true,
      spaceBetween: 0,
      speed: 1200,
      slidesPerView: 1.9,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 4 },
      },
    });
  }

  function adjustViewBox() {
    document.querySelectorAll(".her-svg, .him-svg").forEach((svg) => {
      if (window.innerWidth < 750) {
        svg.setAttribute("viewBox", "0 0 375 126");
      } else {
        svg.setAttribute("viewBox", "0 0 720 292");
      }

      if (window.innerWidth < 750 && svg.classList.contains("mobile--hidden")) {
        svg.remove();
      }
    });
  }

  /**
   * Initializes the Swiper instance for the blog carousel on homepage
   */
  function setupBlogCarousel() {
    new Swiper(".blog-swiper", {
      loop: true,
      slidesPerView: 1.1,
      spaceBetween: 16,
      speed: 1200,
      breakpoints: {
        768: { slidesPerView: 2.3 },
        1024: { slidesPerView: 3.3 },
        1280: { slidesPerView: 4 },
      },
    });
  }

  /**
   * Initializes the Swiper instance for the main product carousel on PDP
   */

  function setupMainProductCarousel() {
    new Swiper(".product-carousel", {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      lazy: false,
      mousewheel: false, 
      allowTouchMove: false, 
      simulateTouch: false, 
    });
  }

  function setupLazyVideos() {
    const lazyVideos = document.querySelectorAll(".lazy-video");

    if (!("IntersectionObserver" in window)) {
      lazyVideos.forEach(loadAndPlayVideo);
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const video = entry.target;
          loadAndPlayVideo(video);
          obs.unobserve(video);
        });
      },
      {
        rootMargin: "0px 0px 50px 0px",
        threshold: 0,
      }
    );

    lazyVideos.forEach((video) => {
      if (video.dataset.lazyLoaded === "true") return;

      isElementInViewport(video)
        ? loadAndPlayVideo(video)
        : observer.observe(video);
    });
  }

  function loadAndPlayVideo(video) {
    if (video.dataset.lazyLoaded === "true") return;

    const isMobile = window.innerWidth <= 768;

    video.querySelectorAll("source").forEach((source) => {
      if (source.dataset.src && !source.src) source.src = source.dataset.src;
    });

    video.dataset.lazyLoaded = "true";

    video.muted = true;
    video.playsInline = true;
    video.setAttribute("playsinline", "");

    video.load();

    // On Mobile NotAutoplayVideo
    if (isMobile) {
      return;
    }

    const playWhenReady = () => {
      video.removeEventListener("canplay", playWhenReady);
      video.play().catch(() => {
        /* ignore autoplay block */
      });
    };
    video.addEventListener("canplay", playWhenReady);
  }

  function isElementInViewport(el) {
    const { top, left, bottom, right } = el.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    return top < innerHeight && bottom > 0 && left < innerWidth && right > 0;
  }

  function triggerHoverWhenFirstCardVisible() {
    const isMobile = window.innerWidth <= 768;
    const firstCard = document.querySelector(".has-video");

    if (!isMobile || !firstCard) return;

    const removeHover = () => {
      firstCard.classList.remove("force-hover");
    };

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            firstCard.classList.add("force-hover");

            const timeoutId = setTimeout(removeHover, 2500);

            document.querySelectorAll(".has-video").forEach((card) => {
              if (card !== firstCard) {
                card.addEventListener(
                  "mouseenter",
                  () => {
                    clearTimeout(timeoutId);
                    removeHover();
                  },
                  { once: true }
                );
              }
            });

            observer.unobserve(firstCard);
          }
        });
      },
      {
        rootMargin: "0px",
        threshold: 0.5,
      }
    );

    observer.observe(firstCard);
  }

  async function rerenderCartDrawer() {
    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      const sectionsRes = await fetch(window.routes.cart_update_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          sections: ["cart-drawer", "cart-icon-bubble"],
          sections_url: window.location.pathname,
        }),
      });

      const parsedState = await sectionsRes.json();
      const drawer = document.querySelector("cart-drawer");

      if (drawer) {
        const cartIsEmpty = parsedState.item_count === 0;
        drawer.classList.toggle("is-empty", cartIsEmpty);

        if (
          parsedState.sections?.["cart-drawer"] &&
          parsedState.sections?.["cart-icon-bubble"]
        ) {
          drawer.renderContents({
            id: null,
            sections: parsedState.sections,
          });
        } else {
          console.warn(
            "Missing cart drawer sections in response:",
            parsedState
          );
        }
      }
    } catch (err) {
      console.error("Error rerendering cart sections:", err);
    }
  }

  /**
   * init() is called once the DOM is ready;
   * it orchestrates all initial functions.
   */
  function init() {
    setupFooterAccordion();
    setupMediaSlider();
    setupWheel();
    setupMainProductCarousel();
    setupRecommendationsCarousel();
    setupBlogCarousel();
    adjustViewBox();
    setupTestimonial();
    setupCollectionCarousel();
    setupLazyVideos();
    triggerHoverWhenFirstCardVisible();
    initAnnouncementLottie();

    if (document.getElementById("cart-recommendations")) {
      setupCartRecommendations("cart-recommendations-desktop-container");
      setupCartRecommendations("cart-recommendations-mobile-container");
    }
  }

  return {
    init: init,
    setupLazyVideos: setupLazyVideos,
    setupCartRecommendations: setupCartRecommendations,
    triggerHoverWhenFirstCardVisible: triggerHoverWhenFirstCardVisible,
    rerenderCartDrawer: rerenderCartDrawer,
    initAnnouncementLottie: initAnnouncementLottie,
  };
})();

document.addEventListener("DOMContentLoaded", function () {
  CustomJS.init();
});
